import React from 'react';

// Import certificate images
import certArduino from '../images/Arduino.PNG';
import certBackend from '../images/BackEnd.png';
import certC from '../images/C.png';
import certDataScience from '../images/DataScince.jpg';
import certRISCV from '../images/RISC-V.png';
import certCareer from '../images/Career.png';
import certBPI1 from '../images/BPI1.png';
import certBPI2 from '../images/BPI2.png';
import certCIDRCON from '../images/CIDRCON.png';
import certHIV from '../images/HIV.jpg';
import certBestResearch from '../images/Best_Research_Prototype.PNG';
import certCpElympics from '../images/CpElympics2026_ E-Certificate.png';
import certParticipation from '../images/Participation.PNG';

export default function ExpertiseSection() {
  const expertiseData = [
    {
      category: 'Technical Skills',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
      ),
      items: [
        { label: 'Programming Languages', value: 'C++, Java, Python, JavaScript' },
        { label: 'Web Development Tools', value: 'ReactJS, HTML/CSS' },
        { label: 'Hardware / Software Tools', value: 'Arduino, MATLAB, Proteus, Git/GitHub' },
        { label: 'Soft Skills', value: 'Problem-solving, Teamwork, Communication, Leadership' }
      ]
    },
    {
      category: 'Arduino Programming',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="4" width="16" height="16" rx="2" ry="2"/>
          <rect x="9" y="9" width="6" height="6"/>
          <line x1="9" y1="1" x2="9" y2="4"/>
          <line x1="15" y1="1" x2="15" y2="4"/>
          <line x1="9" y1="20" x2="9" y2="23"/>
          <line x1="15" y1="20" x2="15" y2="23"/>
          <line x1="20" y1="9" x2="23" y2="9"/>
          <line x1="20" y1="14" x2="23" y2="14"/>
          <line x1="1" y1="9" x2="4" y2="9"/>
          <line x1="1" y1="14" x2="4" y2="14"/>
        </svg>
      ),
      subtitle: 'Technical Training',
      description: 'Comprehensive training in Arduino microcontroller programming, covering hardware interfacing, sensor integration, and embedded systems development.',
      image: certArduino
    },
    {
      category: 'Backend Web Development',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 18 22 12 16 6"/>
          <polyline points="8 6 2 12 8 18"/>
          <line x1="14" y1="4" x2="10" y2="20"/>
        </svg>
      ),
      subtitle: 'Development Bootcamp',
      description: 'Intensive bootcamp focused on server-side development, RESTful APIs, database management, and backend architecture design.',
      image: certBackend
    },
    {
      category: 'C Programming',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 18 22 12 16 6"/>
          <polyline points="8 6 2 12 8 18"/>
          <line x1="14" y1="4" x2="10" y2="20"/>
        </svg>
      ),
      subtitle: 'Programming Institute',
      description: 'Foundational training in C programming language, covering data structures, algorithms, memory management, and system-level programming.',
      image: certC
    },
    {
      category: 'Data Science Fundamentals',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="20" x2="18" y2="10"/>
          <line x1="12" y1="20" x2="12" y2="4"/>
          <line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
      ),
      subtitle: 'Data Analytics Workshop',
      description: 'Introduction to data science principles, statistical analysis, data visualization, and machine learning fundamentals using Python.',
      image: certDataScience
    },
    {
      category: 'RISC-V Architecture',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="2" width="20" height="8" rx="2" ry="2"/>
          <rect x="2" y="14" width="20" height="8" rx="2" ry="2"/>
          <line x1="6" y1="6" x2="6.01" y2="6"/>
          <line x1="6" y1="18" x2="6.01" y2="18"/>
        </svg>
      ),
      subtitle: 'Engineering Seminar',
      description: 'Seminar on RISC-V open-source instruction set architecture, processor design, and hardware-software interface.',
      image: certRISCV
    },
    {
      category: 'BPI Foundational Training',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
          <path d="M6 12v5c0 2 3 3 6 3s6-1 6-3v-5"/>
        </svg>
      ),
      subtitle: 'BPI',
      description: 'Foundational training program covering banking operations, financial services, and professional workplace skills.',
      image: certBPI1
    },
    {
      category: 'Career Development',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      ),
      subtitle: 'Career Workshop',
      description: 'Workshop on professional development, resume building, interview skills, and career planning strategies.',
      image: certCareer
    },
    {
      category: 'BPI Advanced Training',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
          <path d="M6 12v5c0 2 3 3 6 3s6-1 6-3v-5"/>
        </svg>
      ),
      subtitle: 'BPI',
      description: 'Advanced training program focusing on specialized banking services, customer relations, and financial analysis.',
      image: certBPI2
    },
    {
      category: 'CIDRCON Conference',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      subtitle: 'CIDRCON',
      description: 'Participation in CIDRCON conference, engaging with industry professionals and learning about emerging technologies.',
      image: certCIDRCON
    },
    {
      category: 'HIV Awareness Seminar',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
        </svg>
      ),
      subtitle: 'Health Organization',
      description: 'Educational seminar on HIV/AIDS awareness, prevention, treatment, and reducing stigma in communities.',
      image: certHIV
    },
    {
      category: 'Best Research Prototype',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="7"/>
          <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
        </svg>
      ),
      subtitle: 'Research Competition',
      description: 'Awarded for outstanding research prototype demonstrating innovation, technical excellence, and practical application.',
      image: certBestResearch
    },
    {
      category: 'CpElympics 2026 E-Certificate',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="7"/>
          <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
        </svg>
      ),
      subtitle: 'Computer Engineering Olympics',
      description: 'Participation certificate for CpElympics 2026, showcasing competitive skills in computer engineering challenges.',
      image: certCpElympics
    },
    {
      category: 'Participation Certificate',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2"/>
          <path d="M8 21h8"/>
          <path d="M12 17v4"/>
          <path d="M7 10l2 2 4-4"/>
        </svg>
      ),
      subtitle: 'Event Participation',
      description: 'Certificate of participation recognizing active involvement and contribution to the event.',
      image: certParticipation
    }
  ];

  return (
    <section id="expertise" className="section section-alt">
      <div className="section-content">
        <h2 className="section-title">Expertise & Certifications</h2>
        <p style={{ marginBottom: '3rem', fontSize: '1.05rem', opacity: '0.9', maxWidth: '800px' }}>
          Technical skills, tools, and professional certifications that demonstrate my capabilities.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', marginTop: '3rem' }}>
          {expertiseData.map((expertise, index) => (
            <div 
              key={index}
              className="glass-card"
              style={{ 
                padding: '0',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'stretch',
                transition: 'all 0.3s ease',
                position: 'relative'
              }}
            >
              {/* Left Panel - Icon/Image */}
              <div style={{ 
                flex: '0 0 340px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.06) 100%)',
                borderRight: '1px solid var(--glass-border)',
                padding: '3rem 2rem',
                position: 'relative'
              }}>
                {/* Vertical Accent Bar */}
                <div style={{
                  position: 'absolute',
                  left: 0,
                  top: '20%',
                  bottom: '20%',
                  width: '5px',
                  background: 'var(--primary)',
                  borderRadius: '0 4px 4px 0',
                  boxShadow: '0 0 20px var(--primary)'
                }}></div>

                {/* Icon or Certificate Image */}
                {expertise.image ? (
                  <div style={{
                    width: '260px',
                    height: '200px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '20px',
                    border: '2px solid var(--glass-border)',
                    padding: '1rem',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
                    overflow: 'hidden'
                  }}>
                    <img 
                      src={expertise.image} 
                      alt={expertise.category}
                      style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'contain'
                      }} 
                    />
                  </div>
                ) : (
                  <div style={{
                    width: '160px',
                    height: '160px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '20px',
                    border: '2px solid var(--glass-border)',
                    padding: '2rem',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
                    color: 'var(--primary)'
                  }}>
                    {expertise.icon}
                  </div>
                )}
              </div>

              {/* Right Panel - Details */}
              <div style={{ 
                flex: '1',
                padding: '3rem 3.5rem',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                background: 'rgba(0, 0, 0, 0.15)',
                minHeight: '280px'
              }}>
                {/* Category Information */}
                <div style={{ marginBottom: '2.5rem' }}>
                  <h3 style={{ 
                    fontSize: '1.75rem', 
                    marginBottom: '1rem',
                    color: 'var(--text)',
                    lineHeight: '1.3',
                    fontWeight: '700',
                    letterSpacing: '-0.5px'
                  }}>
                    {expertise.category}
                  </h3>
                  
                  {/* Subtitle */}
                  {expertise.subtitle && (
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'flex-start', 
                      gap: '0.75rem',
                      padding: '1rem 0',
                      borderBottom: '2px solid var(--glass-border)'
                    }}>
                      <p style={{ 
                        color: 'var(--text)', 
                        fontWeight: '600',
                        fontSize: '1.05rem',
                        margin: 0,
                        lineHeight: '1.5',
                        opacity: '0.9'
                      }}>
                        Organizer: {expertise.subtitle}
                      </p>
                    </div>
                  )}
                </div>

                {/* Description Card */}
                {expertise.description && (
                  <div style={{ 
                    display: 'flex',
                    gap: '1rem',
                    alignItems: 'flex-start',
                    padding: '1rem 1.25rem',
                    background: 'rgba(255, 255, 255, 0.03)',
                    borderRadius: '10px',
                    border: '1px solid var(--glass-border)',
                    transition: 'all 0.2s ease'
                  }}>
                    {/* Icon Indicator */}
                    <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      background: 'var(--primary)',
                      marginTop: '8px',
                      flexShrink: 0,
                      boxShadow: '0 0 10px var(--primary)'
                    }}></div>
                    
                    <div style={{ flex: 1 }}>
                      <span style={{ 
                        color: 'var(--primary)', 
                        fontWeight: '700',
                        fontSize: '0.8rem',
                        textTransform: 'uppercase',
                        letterSpacing: '1.2px',
                        display: 'block',
                        marginBottom: '0.5rem'
                      }}>
                        Description
                      </span>
                      <span style={{ 
                        color: 'var(--muted)', 
                        fontSize: '1rem',
                        lineHeight: '1.7',
                        display: 'block'
                      }}>
                        {expertise.description}
                      </span>
                    </div>
                  </div>
                )}

                {/* Items (for Technical Skills) */}
                {expertise.items && (
                  <div style={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1.5rem'
                  }}>
                    {expertise.items.map((item, idx) => (
                      <div 
                        key={idx} 
                        style={{ 
                          display: 'flex',
                          gap: '1rem',
                          alignItems: 'flex-start',
                          padding: '1rem 1.25rem',
                          background: 'rgba(255, 255, 255, 0.03)',
                          borderRadius: '10px',
                          border: '1px solid var(--glass-border)',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.06)';
                          e.currentTarget.style.borderColor = 'var(--primary)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                          e.currentTarget.style.borderColor = 'var(--glass-border)';
                        }}
                      >
                        {/* Icon Indicator */}
                        <div style={{
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          background: 'var(--primary)',
                          marginTop: '8px',
                          flexShrink: 0,
                          boxShadow: '0 0 10px var(--primary)'
                        }}></div>
                        
                        <div style={{ flex: 1 }}>
                          <span style={{ 
                            color: 'var(--primary)', 
                            fontWeight: '700',
                            fontSize: '0.8rem',
                            textTransform: 'uppercase',
                            letterSpacing: '1.2px',
                            display: 'block',
                            marginBottom: '0.5rem'
                          }}>
                            {item.label}
                          </span>
                          <span style={{ 
                            color: 'var(--muted)', 
                            fontSize: '1rem',
                            lineHeight: '1.7',
                            display: 'block'
                          }}>
                            {item.value}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Responsive Styles */}
        <style>{`
          @media (max-width: 1024px) {
            .glass-card > div:first-child {
              flex: 0 0 100% !important;
              border-right: none !important;
              border-bottom: 1px solid var(--glass-border) !important;
              padding: 2.5rem 2rem !important;
            }
            .glass-card > div:last-child {
              padding: 2.5rem 2rem !important;
            }
            .glass-card {
              flex-direction: column !important;
            }
          }
        `}</style>

      </div>
    </section>
  );
}
